module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue4.d3899c44.jpg";